import { ProfilerProduct } from "@/features/profiler/types/ProfilerProduct";
import { getAssetPath } from "../../../../../lib/assetPath";
import { useTranslation } from "../../../../../lib/i18n";
import { useDataTranslation } from "../../../../../lib/i18n/data";

type CreateYourOwnStyleProps = {
  feticheFragrance: ProfilerProduct ;
  opulenceFragrance: ProfilerProduct  ;
  sensualityFragrance: ProfilerProduct ;
  mysteryFragrance: ProfilerProduct ;
  eleganceFragrance: ProfilerProduct ;
};

export const CreateYourOwnStyle = ({
  feticheFragrance,
  opulenceFragrance,
  sensualityFragrance,
  mysteryFragrance,
  eleganceFragrance,
}: CreateYourOwnStyleProps) => {
  const { t } = useTranslation();
  const { tData } = useDataTranslation();

  return (
    <div className="flex items-start content-start gap-4 self-stretch flex-wrap">
      <h3 className="text-[#050505] text-center font-minion text-[26px] font-normal self-stretch w-full">
        {t('results.fragrance.createYourOwnStyle')} {feticheFragrance.label} {t('results.fragrance.addTouchOf')}
      </h3>
      <div className="flex items-start justify-center content-center gap-4 self-stretch flex-wrap w-full">
        <AddititonalFragranceCard
          name={opulenceFragrance.label}
          imagePath={`/fragrance-profiler/secondary-fragrances/${opulenceFragrance.id}.avif`}
          adjective={t('results.fragrance.opulence')}
          keywords={opulenceFragrance.keywords}
          olfactiveNotes={tData('products', opulenceFragrance.id, 'olfactiveNotes', opulenceFragrance.olfactiveNotes)}
        />
        <AddititonalFragranceCard
          name={sensualityFragrance.label}
          imagePath={`/fragrance-profiler/secondary-fragrances/${sensualityFragrance.id}.avif`}
          adjective={t('results.fragrance.sensuality')}
          keywords={sensualityFragrance.keywords}
          olfactiveNotes={tData('products', sensualityFragrance.id, 'olfactiveNotes', sensualityFragrance.olfactiveNotes)}
        />
        <AddititonalFragranceCard
          name={mysteryFragrance.label}
          imagePath={`/fragrance-profiler/secondary-fragrances/${mysteryFragrance.id}.avif`}
          adjective={t('results.fragrance.mystery')}
          keywords={mysteryFragrance.keywords}
          olfactiveNotes={tData('products', mysteryFragrance.id, 'olfactiveNotes', mysteryFragrance.olfactiveNotes)}
        />
        <AddititonalFragranceCard
          name={eleganceFragrance.label}
          imagePath={`/fragrance-profiler/secondary-fragrances/${eleganceFragrance.id}.avif`}
          adjective={t('results.fragrance.elegance')}
          keywords={eleganceFragrance.keywords}
          olfactiveNotes={tData('products', eleganceFragrance.id, 'olfactiveNotes', eleganceFragrance.olfactiveNotes)}
        />
      </div>
    </div>
  );
};

export const AddititonalFragranceCard = ({
  name,
  imagePath,
  adjective,
  keywords,
  olfactiveNotes,
}: {
  name: string;
  imagePath: string;
  adjective: string;
  keywords: string;
  olfactiveNotes: string;
}) => {
  return (
    <div className="flex flex-col justify-center items-center gap-4 w-[180px]">
      <img src={getAssetPath(imagePath)} alt={imagePath} className="h-[224px] aspect-square object-cover" />
      <div className="flex flex-col justify-center items-center gap-1">
        <p className="text-[#CE0A2C] text-center font-minion text-[14px] font-normal leading-[150%] self-stretch">
          {name}
        </p>
        <h3 className="text-[#050505] text-center font-bebas-kai text-[24px] font-normal leading-normal self-stretch">
          {adjective}
        </h3>
        <p className="text-[#050505] text-center font-garamond-italic text-[16px] italic font-normal leading-normal self-stretch">
          {keywords}
        </p>
        <p className="text-[#050505] text-center font-garamond-italic text-[16px] italic font-normal leading-normal self-stretch">
          {olfactiveNotes}
        </p>
      </div>
    </div>
  );
};
